
export const apiFacebookAuthGet = () => "/api/facebook_auth";

export const apiNotificationTestMessagePost = () => "/api/notification/test_message";

export const apiNotificationUpdateUserPost = () => "/api/notification/update_user";

export const apiSendTelemetryPost = () => "/api/send_telemetry";

export const apiTeamIdLiveAssetsGet = () => "/api/{teamId}/live_assets";

